import { OverrideProps, cn } from '@/lib/utils'

export type LoadingSpinnerProps = OverrideProps<
  'svg',
  {
    classNames?: {
      svg?: string
      circle?: string
      path?: string
    }
  }
>

export function LoadingSpinner({ classNames, className, ...props }: LoadingSpinnerProps) {
  return (
    <svg
      className={cn('animate-spin', classNames?.svg, className)}
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <circle
        className={cn('opacity-25', classNames?.circle)}
        stroke="currentColor"
        cx="12"
        cy="12"
        r="10"
        strokeWidth="4"
      />
      <path
        className={cn('opacity-75', classNames?.path)}
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  )
}
